import { GraphQLError } from 'graphql';
export const ERROR_SYMBOL = Symbol('subschemaErrors');
export function relocatedError(originalError, path) {
    return new GraphQLError(originalError.message, originalError.nodes, originalError.source, originalError.positions, path === null ? undefined : path === undefined ? originalError.path : path, originalError.originalError, originalError.extensions);
}
export function slicedError(originalError) {
    return relocatedError(originalError, originalError.path != null ? originalError.path.slice(1) : undefined);
}
export function getErrorsByPathSegment(errors) {
    const record = Object.create(null);
    errors.forEach(error => {
        if (!error.path || error.path.length < 2) {
            return;
        }
        const pathSegment = error.path[1];
        const current = pathSegment in record ? record[pathSegment] : [];
        current.push(slicedError(error));
        record[pathSegment] = current;
    });
    return record;
}
export function setErrors(result, errors) {
    result[ERROR_SYMBOL] = errors;
}
export function getErrors(result, pathSegment) {
    const errors = result != null ? result[ERROR_SYMBOL] : result;
    if (!Array.isArray(errors)) {
        return null;
    }
    const fieldErrors = [];
    for (const error of errors) {
        if (!error.path || error.path[0] === pathSegment) {
            fieldErrors.push(error);
        }
    }
    return fieldErrors;
}
//# sourceMappingURL=errors.js.map